import { buildEpgUrl } from '~/entities/epg/lib'
import { getEpgRegionFromAlias } from '~/features/ctvLandingRegion'
import { getLandingRegionUrlFromAlias } from '~/features/landingRegion'
import {
  CTV_REGION_CATEGORY_IDS,
  CTV_REGIONS_IDS,
  CTV_REGIONS_NAMES,
  GLOBAL_REGION,
} from '~/shared/constants'
import { PATH } from '~/shared/constants/path'

export type CtvAfricaSubregionSlug = 'nigeria' | 'ghana' | 'kenya'

export const isCtvAfricaSubregionSlug = (
  slug: string | null | undefined
): slug is CtvAfricaSubregionSlug =>
  slug === 'nigeria' || slug === 'ghana' || slug === 'kenya'

export type BuildHomeMenuUrlParams = {
  isCTVLandingPage: boolean
  ctvLandingRegion: string | null | undefined
  preferredRegionAlias: string | undefined
}

export function buildHomeMenuUrl({
  isCTVLandingPage,
  ctvLandingRegion,
  preferredRegionAlias,
}: BuildHomeMenuUrlParams): string {
  if (isCTVLandingPage) {
    const isGenericCtvLandingRegion = ctvLandingRegion === GLOBAL_REGION
    if (isGenericCtvLandingRegion) {
      return `${PATH.HOME}${getLandingRegionUrlFromAlias(preferredRegionAlias)}`
    }
    return `${PATH.HOME}${ctvLandingRegion ? getLandingRegionUrlFromAlias(ctvLandingRegion) : ''}`
  }

  return `${PATH.HOME}${preferredRegionAlias ? getLandingRegionUrlFromAlias(preferredRegionAlias) : ''}`
}

export type BuildEpgMenuUrlParams = {
  isCTVLandingPage: boolean
  ctvLandingRegion: string | null | undefined
  ctvLandingPageSlug: string | null | undefined
  preferredRegionAlias: string | undefined
}

export function buildEpgMenuUrl({
  isCTVLandingPage,
  ctvLandingRegion,
  ctvLandingPageSlug,
  preferredRegionAlias,
}: BuildEpgMenuUrlParams): string {
  if (isCTVLandingPage) {
    const isGenericCtvLandingRegion = ctvLandingRegion === GLOBAL_REGION
    if (isGenericCtvLandingRegion) {
      return `${PATH.LIVE}${PATH.CATEGORIES}/${getEpgRegionFromAlias(preferredRegionAlias)}`
    }
    if (isCtvAfricaSubregionSlug(ctvLandingPageSlug)) {
      return buildEpgUrl({
        regionId: CTV_REGIONS_IDS.africa,
        regionTitle: CTV_REGIONS_NAMES.africa,
        categoryId: CTV_REGION_CATEGORY_IDS[ctvLandingPageSlug],
        categoryTitle: CTV_REGIONS_NAMES[ctvLandingPageSlug],
      })
    }
    return `${PATH.LIVE}${PATH.CATEGORIES}/${ctvLandingRegion ? getEpgRegionFromAlias(ctvLandingRegion) : ''}`
  }

  return `${PATH.LIVE}${PATH.CATEGORIES}`
}
